import React, { useState } from "react";
import styled from "styled-components";
import FormField from "../../../FormField";

const DescriptionParagraph = styled.p`
  font-size: 16px;
  margin-bottom: 22px;
  line-height: 1.6em;
`;

const ProjectDescription = ({ edit, description, handle_Description }) => {
  const [descriptionValue, setDescription] = useState(description);

  // TO DO - handle change + handle errors
  const handleDescription = (e) => {
    setDescription(e.target.value);
    handle_Description(e.target.value);
  };

  return (
    <>
      {edit ? (
        <FormField label="Description" id="project_description">
          <textarea
            id="project_description"
            rows="4"
            placeholder="Enter description"
            value={description}
            onChange={handleDescription}
          />
        </FormField>
      ) : (
        <DescriptionParagraph>{description === null ? 'No Description' : description}</DescriptionParagraph>
      )}
    </>
  );
};

export default ProjectDescription;
